export enum DataLayerT2SKey {
    TrackingId = 'trackingId',
}
